export enum ReminderScales {
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum ReminderDirections {
  Before = 'before',
  After = 'after',
}

export enum ReminderTypes {
  Available = 'available',
  Due = 'due',
}

export enum ReminderDefaults {
  TimeShift = -10,
  Value = 10,
}
